<template>
  <dr-wrapper class="dr-spacer-wrapper" v-if="isInEditorMode" v-bind="$props" v-on="wrapOn" >
  </dr-wrapper>
    <v-spacer v-else-if="isVisible" :class="evaluateClasses(classes)" />
</template>

<script>
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'

export default {
  mixins: [mixin, inputMixin]
}
</script>

<style>
.dr-spacer-wrapper{
    border: 1px dotted gray;
    border-radius: 2px;
    min-height: 30px;
    background: #80808080;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}
.dr-spacer-wrapper::after{
  content: "SPACER";
}
</style>
